/**
 * @generated SignedSource<<18a3db031bb7a01bec23b23bdb22d7be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMappingDialogMutation$variables = {
  id: number;
};
export type DeleteMappingDialogMutation$data = {
  readonly delete_sys_mapping_set_values: {
    readonly affected_rows: number;
  } | null;
};
export type DeleteMappingDialogMutation = {
  response: DeleteMappingDialogMutation$data;
  variables: DeleteMappingDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "mapping_set_value_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_mapping_set_values_mutation_response",
    "kind": "LinkedField",
    "name": "delete_sys_mapping_set_values",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affected_rows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteMappingDialogMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteMappingDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9b715cff0c76e79bbc6db54dc5b40682",
    "id": null,
    "metadata": {},
    "name": "DeleteMappingDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteMappingDialogMutation(\n  $id: Int!\n) {\n  delete_sys_mapping_set_values(where: {mapping_set_value_id: {_eq: $id}}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa3cad4d339031cd7dcc98de49818440";

export default node;
